module.exports = __webpack_public_path__ + "static/img/jb2.a8e4d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/jb2.png
// module id = t0PD
// module chunks = 0